import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { MediaDownloadTokenQuery } from './MediaDownloadTokenQuery.graphql.ts';
import type {
	MediaDownloadTokenQuery as MediaDownloadTokenQueryType,
	MediaDownloadTokenQueryVariables as MediaDownloadTokenQueryVariablesType,
} from './__types__/MediaDownloadTokenQuery.ts';

export const preloadMediaToken = async (contentId: string) => {
	const response = await query<MediaDownloadTokenQueryType, MediaDownloadTokenQueryVariablesType>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: MediaDownloadTokenQuery,
		variables: {
			contentId,
			status: ['current', 'draft', 'archived'],
		},
	});

	// eslint-disable-next-line check-react-ssr-usage/no-react-ssr
	if (process.env.REACT_SSR) {
		const { mediaConfigRecorder } = await import(
			/* webpackChunkName: "loadable-confluencessr-utilities-objectrecorder" */ '@confluence/ssr-utilities/entry-points/ObjectRecorder.ts'
		);
		mediaConfigRecorder.set({
			clientId: response?.data?.mediaConfiguration?.clientId || '',
			baseUrl: response?.data?.mediaConfiguration?.fileStoreUrl || '',
			token: response?.data?.content?.nodes?.[0]?.body?.atlas_doc_format?.mediaToken?.token || '',
		});
	}

	return response;
};
